module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', {
    staticClass: "hero hero-center",
    class: {
      heroHome: _vm.heroHome
    }
  }, [_c('a', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }, {
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#section'),
      expression: "'#section'"
    }],
    staticClass: "arrow-down",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), ((_vm.props.background_video___desktop.value) && (!this.$breakpoints.isMobile())) ? _c('div', {
    staticClass: "hero-video-mask"
  }, [_c('div', {
    staticClass: "overlay-gradient"
  }), _vm._v(" "), _c('video', {
    attrs: {
      "autoloop": "",
      "loop": "",
      "autoplay": "",
      "muted": "",
      "preload": "metadata"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.background_video___desktop.value
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hero-title-container"
  }, [_c('div', {
    staticClass: "container-fluid fullwidth",
    class: {
      'text-center': _vm.heroHome
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.props.header_title) ? _c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "headline"
  }, [_c('span', {
    staticClass: "splitted",
    attrs: {
      "id": "splitWord"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.props.header_title.value) + "\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.props.header_description) ? _c('h3', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "subheadline"
  }, [_vm._v(_vm._s(_vm.props.header_description.value))]) : _vm._e(), _vm._v(" "), (_vm.lightbox) ? _c('a', {
    staticClass: "btn_orange",
    on: {
      "click": function($event) {
        return _vm.showModal()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tWatch video\n\t\t\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('span', {
    ref: "toTop",
    staticClass: "toTop"
  })]) : _c('div', {
    staticClass: "hero-image-mask"
  }, [_c('div', {
    staticClass: "hero-title-container"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "container-fluid fullwidth",
    class: {
      'text-center': _vm.heroHome
    }
  }, [(_vm.props.header_title) ? _c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "headline"
  }, [_c('span', {
    staticClass: "splitted",
    attrs: {
      "id": "splitWord"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.props.header_title.value) + "\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.props.header_description) ? _c('h3', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "subheadline"
  }, [_vm._v(_vm._s(_vm.props.header_description.value))]) : _vm._e(), _vm._v(" "), (_vm.lightbox) ? _c('a', {
    staticClass: "btn_orange",
    on: {
      "click": function($event) {
        return _vm.showModal()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tWatch video\n\t\t\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), (_vm.props.background_image___desktop.value) ? [_c('div', {
    staticClass: "overlay-gradient"
  }), _vm._v(" "), (_vm.props.background_image___desktop.value[0]) ? _c('div', {
    staticClass: "hero-image hidden-xs ",
    style: (_vm.setBackgroundImage(_vm.props.background_image___desktop.value[0].url))
  }) : _vm._e(), _vm._v(" "), (_vm.props.background_image___mobile.value[0]) ? _c('div', {
    staticClass: "hero-image hidden-sm",
    style: (_vm.setBackgroundImage(_vm.props.background_image___mobile.value[0].url))
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.lightbox) ? _c('modal', {
    attrs: {
      "name": "LightboxVideo",
      "adaptive": true,
      "height": 'auto',
      "width": 1100
    },
    on: {
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "embed-container"
  }, [_c('div', {
    staticClass: "top-right",
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$modal.hide('LightboxVideo')
      }
    }
  })]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": 'https://player.vimeo.com/video/' + _vm.props.vimeo_id.value + '?autoplay=1&loop=1&title=0&byline=0&portrait=0&api=1',
      "width": "800",
      "height": "450",
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    }
  })])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-534b0fc8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero.vue
// module id = 1523
// module chunks = 0